import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import localePt from '@angular/common/locales/pt';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LucideAngularModule } from 'lucide-angular';
import {
  AlertTriangle,
  BookOpen,
  Calendar,
  ChevronDown,
  Eye,
  Filter,
  Loader2,
  Search,
  X
} from 'lucide-angular';

import { ModalShellComponent } from '@infrastructure/ui/components/modals/modal-shell/modal-shell.component';
import { DatepickerComponent } from '@infrastructure/ui/components/forms/datepicker/datepicker.component';
import { PageTitleModule } from '@infrastructure/ui/components/page-title/page-title.module';
import { SharedModule } from '@shared/shared.module';

import { SituacaoFilterDropdownComponent } from '@infrastructure/ui/components/forms/situacao-filter-dropdown/situacao-filter-dropdown.component';
import { PeriodoSelectComponent } from '@infrastructure/ui/components/forms/periodo-select/periodo-select.component';
import { PlanejamentoAulaComponent } from './planejamento-aula.component';
import { PlanejamentoAulaListComponent } from './planejamento-aula-list.component';
import { PlanejamentoAulaDetailComponent } from './planejamento-aula-detail.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    PlanejamentoAulaComponent,
    PlanejamentoAulaListComponent,
    PlanejamentoAulaDetailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    ModalShellComponent,
    DatepickerComponent,
    PageTitleModule,
    SharedModule,
    SituacaoFilterDropdownComponent,
    PeriodoSelectComponent,
    LucideAngularModule.pick({
      AlertTriangle,
      BookOpen,
      Calendar,
      ChevronDown,
      Eye,
      Filter,
      Loader2,
      Search,
      X
    })
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ],
  exports: [PlanejamentoAulaComponent]
})
export class PlanejamentoAulaModule { }

